import axios from "axios";

const BASE_URL = "https://api.mm-watch.com/";

export const fetchFromAPI = async (url) => {
  const { data } = await axios.get(`${BASE_URL}${url}`);
  return data;
};
